import api from '@services/api';
import { TermApi, UserTermDto } from '@services/generated';
import { rootApi } from '@store/root-api';
import appHelpers from '@utils/app-urls';
import { handleErrors } from 'services/helpers';

const API_URL = appHelpers.getEndpointUrl();

const termsClient = new TermApi(
  undefined,
  new URL(API_URL, process.env.REACT_APP_API_URL).href,
  api,
);

const termsAndConditionsApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    getUserTerms: builder.query<UserTermDto[], void>({
      queryFn: () => handleErrors(() => termsClient.getUserTerms()),
      providesTags: [{ type: 'UserTerms', id: 'LIST' }],
    }),
    acceptUserTerms: builder.mutation<void, string>({
      queryFn: termCode =>
        handleErrors(async () => {
          return await termsClient.acceptTerm(termCode);
        }),
      invalidatesTags: [{ type: 'UserTerms', id: 'LIST' }],
    }),
  }),
});

export const { useAcceptUserTermsMutation, useGetUserTermsQuery } =
  termsAndConditionsApi;
